export default "__VITE_ASSET__iQZY6E8a__"